<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card flat class="no-display">
      <br>
      <v-row class="row" dense justify="center">
        <v-col cols="2">
          <p class="mb-2"><b>Leave Academic Year</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
          <v-autocomplete dense v-model="editedItem.leaveacademicyear" :items="leave_academic_year_list" item-text="ay"
            item-value="id" label="Leave Academic Year" single-line rounded outlined return-object
            hint="Please Select Academic Year"></v-autocomplete>
        </v-col>

        <v-col cols="2">
          <p class="mb-2"><b> Leave Type</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
          <v-autocomplete dense v-model="editedItem.leavetype" :items="leave_type_list" label="Leave Type"
            item-text="type" item-value="id" single-line rounded outlined multiple
            hint="Select Leave Type"></v-autocomplete>
        </v-col>

        <v-col cols="4">
          <p class="mb-2"><b>Employee</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
          <v-autocomplete dense v-model="editedItem.employee" :items="employee_list" item-text="name" item-value="id"
            label="Employee" single-line rounded outlined hint="Select Employee"></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn color="button" @click="fetchLeaveBalanceReports()" class="mt-9 button">Fetch Report</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="leave_balance_report_list != ''">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line background-color="white"
          hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-btn small rounded color="success" outlined @click="fnExcelReport('my-table-id', 'LeaveBalanceReport')"
          class="mr-4">
          <v-icon color="success">mdi-export</v-icon>Export
        </v-btn>
        <v-btn small outlined color="warning" @click="print()" rounded>
          <v-icon left>mdi-printer</v-icon> Print
        </v-btn>
      </v-toolbar>

      <!-- new simple table shiv -->
      <div id="my-table-id">
        <v-simple-table fixed-header dense class="elevation-1 mytable">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Employee Name</th>
              <th>Leave Type</th>
              <th>Leave Academic Year</th>
              <th>Number Of Days</th>
              <th>Total Leaves(Days)</th>
              <th>Leaves In-Process(Days)</th>
              <th>Total Avalied Leaves(Days)</th>
              <th>Total Leaves Cencelled(Days)</th>
              <th>Balance Leaves(Days)</th>
            </tr>
          </thead>
          <tbody v-for="(s, index) in filteredLeaveBalanceReportList" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                {{ s.instructor }}
              </td>
              <td>{{ s.leavetype }}</td>
              <td>{{ s.leaveacademicyear }}</td>
              <td>
                {{ s.numberofdays }}
              </td>
              <td>
                {{ s.totalleaves }}
              </td>
              <td>
                {{ s.leavesinprogress }}
              </td>
              <td>
                {{ s.availedleaves }}
              </td>
              <td>
                {{ s.cancelled }}
              </td>
              <td>
                {{ s.balanceleaves }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      castId: false,
    },
    menu: "",
    menu1: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: null,
    dialog: false,
    table_fields: {
      "Employee Name": "instructor",
      "Leave Type ": "leavetype",
      "Leave Academic Year": "leaveacademicyear",
      "Total Leaves(Days)": "totalleaves",
      "Leaves In-Process(Days)": "leavesinprogress",
      "Total Avalied Leaves(Days)": "availedleaves",
      "Balance Leaves(Days)": "balanceleaves",
    },
    headers: [
      {
        text: "Employee Name",
        align: "left",
        sortable: true,
        value: "instructor",
      },
      {
        text: "Leave Type",
        align: "left",
        sortable: true,
        value: "leavetype",
      },
      {
        text: "Leave Academic Year",
        align: "left",
        sortable: false,
        value: "leaveacademicyear",
      },
      {
        text: "Total Leaves(Days)",
        align: "left",
        sortable: false,
        value: "totalleaves",
      },
      {
        text: "Leaves In-Process(Days)",
        align: "left",
        sortable: false,
        value: "leavesinprogress",
      },
      {
        text: "Total Avalied Leaves(Days)",
        align: "left",
        sortable: false,
        value: "availedleaves",
      },
      {
        text: "Balance Leaves(Days)",
        align: "left",
        sortable: false,
        value: "balanceleaves",
      },
    ],
    leave_academic_year_list: [],
    leave_type_list: [],
    employee_list: [],
    leave_balance_report_list: [],
    editedItem: {
      leaveacademicyear: "",
      leavetype: null,
      employee: null,
      fromdate: "",
      todate: "",
    },
  }),

  mounted() {
    this.onLoad();
  },
  computed: {
    filteredLeaveBalanceReportList() {
      if (!this.search) {
        return this.leave_balance_report_list;
      }
      const searchTerm = this.search.toLowerCase();
      return this.leave_balance_report_list.filter(item => {
        return (
          item.instructor.toLowerCase().includes(searchTerm) ||
          item.leavetype.toLowerCase().includes(searchTerm)
        );
      });
    }
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    fetchLeaveBalanceReports() {
      this.overlay = true;
      if (
        this.editedItem.leaveacademicyear == "" ||
        this.editedItem.employee == ""
      ) {
        this.showSnackbar("#b71c1c", "Please Fill All The Fields");
      } else {
        axios
          .post("/LeaveManagement/fetchLeaveBalanceReports", this.editedItem)
          .then((res) => {
            if (res.data.flag == "Yes") {
              if ((this.load = true)) {
                this.overlay = false;
                this.leave_balance_report_list =
                  res.data.leave_balance_report_list;
              }
            } else if (res.data.msg == "NDF") {
              this.showSnackbar("#b71c1c", "No Data Found");
              this.onLoad();
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            this.overlay = false;
          });
      }
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/LeaveManagement/getLeaveBalanceData")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.leave_academic_year_list = res.data.leave_academic_year_list;
              this.leave_type_list = res.data.leave_type_list;
              this.employee_list = res.data.employee_list;
              // this.leave_balance_report_list =
              //   res.data.leave_balance_report_list;
              this.editedItem.leaveacademicyear = res.data.clay;
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          //window.console.log("Errro------>"+error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
td,
th {
  border: 1px solid #e3e1e1;
}

tr,
tbody {
  border-bottom: 1px solid #e3e1e1;
  border: 1px solid #e3e1e1;
}

td {
  font-weight: bold;
}

sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

i {
  font-size: 26px;
  cursor: pointer;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #e3e1e1;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  border: 1px solid #e3e1e1;
  text-align: center;
}

@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}

@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}

@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}

@media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }

  @page {
    size: A4;
    margin: 0px;
    size: 18.5in 19in;
  }

  .box {
    overflow-x: hidden;
    border: none !important;
  }

  .mytable {
    height: auto !important;
    overflow: hidden !important;
  }

  td {
    font-size: large !important;
  }

  thead th {
    font-size: large !important;
  }
}

.mytable {
  height: 500px;
  overflow-y: scroll;
}
</style>